import { userService } from '../services';
import config from '../config/config';

export const AddressAction = {
    AddressList,
    InstalledGps,
    KmlFileUpload,
    AllRemarksShowDetails,
    Addremarks,
    AllRemarksShowDetails1,
    Addremarks1,
    getPositionsOfUser
};

async function getPositionsOfUser(payload) {
    
    try {
        let apiEndpoint =  `${config.baseUrl}${config.apiName.liveTracking}`
        
        let response = await userService.post(apiEndpoint,payload);
        console.log(response);
        if (response && response.status == 200 && 201) {
            return (response.data);
        }
        else {
            console.log(response)
            if (response.status != 500) {
                // alert(response.data.message);
            }
            if (response.status == 401) {
                alert(response.data.message);
            }
            return null;
        }
    }
    catch(error) {
        console.log("error", error);
        return null;
    }
}

async function AddressList(payload) {
    
    try {
        let apiEndpoint =  `${JSON.parse(localStorage.getItem('data')).addressUrl}`
        
        let response = await userService.post(apiEndpoint,payload);
        console.log(response);
        if (response && response.status == 200 && 201) {
            return (response.data);
        }
        else {
            console.log(response)
            if (response.status != 500) {
                // alert(response.data.message);
            }
            if (response.status == 401) {
                alert(response.data.message);
            }
            return null;
        }
    }
    catch(error) {
        console.log("error", error);
        return null;
    }
}

async function InstalledGps(payload) {
    
    try {
        let apiEndpoint =  `${JSON.parse(localStorage.getItem('config')).baseUrl}${config.apiName.totalInstallGps}`
        
        let response = await userService.post(apiEndpoint,payload);
        console.log(response);
        if (response && response.status == 200 && 201) {
            return (response.data);
        }
        else {
            console.log(response)
            if (response.status != 500) {
                // alert(response.data.message);
            }
            if (response.status == 401) {
                alert(response.data.message);
            }
            return null;
        }
    }
    catch(error) {
        console.log("error", error);
        return null;
    }
}


async function KmlFileUpload(payload) {
    
    try {
        let apiEndpoint =  `${JSON.parse(localStorage.getItem('config')).baseUrl}${config.apiName.KmlFileUploding}`
        
        let response = await userService.post(apiEndpoint,payload);
        console.log(response);

        if (response && response.status ==  201) {
            return (response.data);
        }
        else {
            console.log(response)
            alert(response.data.message);

            // if (response.status != 500) {
            //     return response;
            //     // alert(response.data.responseDescription);
            // } else
            // if (response.status == 401) {
            //     alert(response.data.message);
            // } else {
            //     alert(response.data.responseDescription);
            //     // return (response);
            // }
            return null;
        }
       
    }
    catch(error) {
        console.log("error", error);
        return null;
    }
}

async function AllRemarksShowDetails(payload){
    try{
        let apiEndpoint= `${JSON.parse(localStorage.getItem('config')).baseUrl}${config.apiName.AllRemarksShowDetails}?id=${payload.id}&alertId=${payload.alertId}&alertType=${payload.alertType}&remarks=${payload.remarks}&alertActionStatusId&=${payload.alertActionStatusId}&alertActionStatusName=${payload.alertActionStatusName}`
        const response=await userService.post(apiEndpoint,payload)
        if(response && response.status==200){
            return response.data
          }
          else{
            console.log("error")
          }

    }
    catch(error){
        console.log(error)

    }

}



async function Addremarks(payload) {
    console.log(payload)
    console.log(`${config.apiName.Addremarks}`,12)
    try {
        let apiEndpoint = `${JSON.parse(localStorage.getItem('config')).baseUrl}${config.apiName.Addremarks}`
        let response = await userService.post(apiEndpoint, payload);
        console.log(response);
        //debugger
        if (response &&  response.status == 200) {
            return (response.data);
        }
        else {
            console.log(response)
            //alert(response.data.message);

            return null;
        }
    }
    catch(error) {
        console.log("error", error);
        return null;
    }
}

async function AllRemarksShowDetails1(payload){
    try{
        let apiEndpoint= `${JSON.parse(localStorage.getItem('config')).baseUrl}${config.apiName.AllRemarksShowDetails1}`
        const response=await userService.post(apiEndpoint,payload)
        if(response && response.status==200){
            
            return response.data
          }
          else{
            console.log("error")
          }

    }
    catch(error){
        console.log(error)

    }

}



async function Addremarks1(payload) {
    console.log(payload)
    try {
        let apiEndpoint = `${JSON.parse(localStorage.getItem('config')).baseUrl}${config.apiName.Addremarks1}`
        let response = await userService.post(apiEndpoint, payload);
        console.log(response);
        //debugger
        if (response &&  response.status == 200) {
            return (response.data);
        }
        else {
            console.log(response)
            alert(response.data.message);
            return null;
        }
    }
    catch(error) {
        console.log("error", error);
        return null;
    }
}
